import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './form-field.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


export const formFieldValidation = ['none', 'error', 'success'] as const
export type formFieldValidationTypes = typeof formFieldValidation

const LABELLED_DATA_FLAG = 'cseFormFieldLabelled'
let formFieldLabelIds = 0

@customElement('cse-form-field')
export class CSEFormField extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  private labelSlot: HTMLSlotElement | null = null
  private controlSlot: HTMLSlotElement | null = null

  override firstUpdated() {
    this.labelSlot = this.shadowRoot?.querySelector('slot[name="label"]') as HTMLSlotElement | null
    this.controlSlot = this.shadowRoot?.querySelector('slot:not([name])') as HTMLSlotElement | null

    this.labelSlot?.addEventListener('slotchange', this.updateAccessibility)
    this.controlSlot?.addEventListener('slotchange', this.updateAccessibility)

    this.updateAccessibility()
  }

  override disconnectedCallback(): void {
    this.labelSlot?.removeEventListener('slotchange', this.updateAccessibility)
    this.controlSlot?.removeEventListener('slotchange', this.updateAccessibility)
    super.disconnectedCallback()
  }

  private readonly updateAccessibility = () => {
    const label = this.querySelector('[slot="label"]') as HTMLElement | null
    const controls = Array.from(this.children).filter((child): child is HTMLElement => {
      return child instanceof HTMLElement && child.slot === ''
    })

    if (!label) {
      controls.forEach(control => {
        if (control.dataset[LABELLED_DATA_FLAG] === 'true') {
          control.removeAttribute('aria-labelledby')
          delete control.dataset[LABELLED_DATA_FLAG]
        }
      })
      return
    }

    let labelId = label.getAttribute('id')
    if (!labelId) {
      labelId = `cse-form-field-label-${++formFieldLabelIds}`
      label.setAttribute('id', labelId)
    }

    controls.forEach(control => {
      const isCustomLabelled = control.hasAttribute('aria-labelledby') && control.dataset[LABELLED_DATA_FLAG] !== 'true'
      if (isCustomLabelled) {
        return
      }

      control.setAttribute('aria-labelledby', labelId as string)
      control.dataset[LABELLED_DATA_FLAG] = 'true'
    })
  }

  override render() {
    return html`
      <div class="cse-form-field">
        <slot name="label"></slot>
        <slot></slot>
        <slot name="help-text" class="font-caption-m help-text"></slot>
        <slot name="invalid-text" class="font-caption-m invalid-text"></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-form-field': CSEFormField
  }
}
